document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Lightbox Script Loaded");

    let lightbox = document.getElementById("video-lightbox");
    let openButton = document.getElementById("open-video-lightbox");
    let closeButton = document.querySelector(".close-lightbox");
    let vimeoIframe = document.getElementById("vimeo-video");

    if (!openButton || !lightbox || !closeButton || !vimeoIframe) {
        console.error("❌ ERROR: Lightbox elements missing");
        return;
    }

    // ✅ Open Lightbox & Load Vimeo Video
    openButton.addEventListener("click", function () {
        console.log("📽️ Lightbox Opened!");

        let vimeoURL = vimeoIframe.getAttribute("data-src"); // Retrieves the metafield

        if (vimeoURL) {
            console.log("🔗 Setting Vimeo Video Source:", vimeoURL);
            vimeoIframe.src = vimeoURL + "?autoplay=1";
        } else {
            console.error("❌ ERROR: Vimeo URL Not Found!");
        }

        lightbox.style.display = "flex";
    });

    // ✅ Function to Close Lightbox and Stop Video
    function closeLightbox() {
        console.log("❌ Closing Lightbox");
        lightbox.style.display = "none";

        // Stop the Vimeo video by resetting the iframe source
        let vimeoSrc = vimeoIframe.getAttribute("data-src");
        vimeoIframe.src = ""; // Clear iframe
        setTimeout(() => {
            vimeoIframe.src = vimeoSrc; // Reload after delay
        }, 500);
    }

    // ✅ Attach Event Listeners for Closing
    closeButton.addEventListener("click", function (event) {
        event.stopPropagation();
        console.log("❌ Close button clicked!");
        closeLightbox();
    });

    lightbox.addEventListener("click", function (event) {
        if (event.target === lightbox) {
            console.log("❌ Lightbox Closed from outside click");
            closeLightbox();
        }
    });
});
